import React from 'react';
import { setCurrentView } from 'core/utils';
import { BillingChargesViewStore } from '../stores';
import { BillingChargesTemplate } from 'themes/modules/billing/pages';

@setCurrentView(rootStore => new BillingChargesViewStore(rootStore), 'billingChargesViewStore')
class BillingCharges extends React.Component {
	render() {
		return <BillingChargesTemplate {...this.props} viewStore={this.props.billingChargesViewStore} />;
	}
}

export default BillingCharges;
